export default __webpack_public_path__ + "static/media/2428.d9853806.jpg";